export function numberInRange({
	props,
	propName,
	componentName,
	isRequired,
	rangeStart,
	rangeEnd,
}) {
	if (
		typeof rangeStart !== 'number' ||
		typeof rangeEnd !== 'number' ||
		rangeStart >= rangeEnd
	) {
		return new Error(
			`Invalid rangeStart or rangeEnd is passed to ${componentName} ${propName} prop validator`,
		);
	}

	const value = props && props[propName];
	if (isRequired && !value && value !== 0) {
		return new Error(
			`Invalid prop ${propName} is supplied to ${componentName}. ${propName} is required`,
		);
	}

	if (value && typeof value !== 'number') {
		return new Error(
			`Invalid prop ${propName} is supplied to ${componentName}. ${propName} should be a number`,
		);
	}

	if (value < rangeStart || value > rangeEnd) {
		return new Error(
			`Invalid prop ${propName} is supplied to ${componentName}. ${propName} is not in ${rangeStart} to ${rangeEnd} range`,
		);
	}

	return null;
}
